<template>
<div class="mt90">
  <el-row class="pr-bgimg pr-bg-article"></el-row>
  <el-row class="pr-container bg-white mt-160 pb-6 model-industry">
    <div class="pl-5">
      <h2 class="mt-6 mb-0 f-w500 font28 col333">最新动态</h2>
      <p class="font16 colc1 mb-5 mt-0">News Center </p>
    </div>
    <el-container class="pt-5 px-5 clear">
      <el-aside width="200px" heigth="100%">
        <el-menu router :default-openeds="openeds">
          <el-submenu v-for="menu in articleTree" :key="menu.id" :index="String(menu.id)">
            <template slot="title">
              <span>{{menu.name}}</span>
            </template>
            <el-menu-item-group v-if="menu.node.length">
              <el-menu-item v-for="menuItem in menu.node" :key="menuItem.id">
                <router-link :to="'/article/list/' + String(menuItem.id)">{{menuItem.name}}</router-link>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <router-view></router-view>
    </el-container>
  </el-row>
  </div>
</template>

<script>
export default {
  name: "IndustryInformation",
  data() {
    return {
      articleTree: [],
      openeds: [],
      uniqueOpened: false
    };
  },
  created() {
    this.getArticleTree();
  },
  methods: {
    getArticleTree:function (page, cate) {
      var _this = this;
      _this.axios.get("/protal/article/tree")
      .then(function (res) {
        var data = res.data
        if(data.code == 200){
          for (let i in data.data) {
            _this.openeds.push(JSON.stringify(data.data[i].id))
          }
          _this.articleTree = data.data;
        }
      })
      .catch(function (error) {
        // 请求发送失败
        console.log(error);
      });
    }
  }
};



</script>

<style lang="scss">
.pr-bg-article {
  background-image: url('../../assets/images/article/article-bg.jpg');
}
.model-industry{
  $bgCol: #f2f2f2;
  .el-aside {
    margin-bottom: 80px;
    background: $bgCol;
    padding: 0 24px;
    height: 100%;
    .el-submenu__title {
      font-size: 16px;
      color: #333;
      font-weight: 700;
      padding-left: 12px !important;
      &:hover{
        background: transparent;
      }
    }
    .el-menu {
      border: none;
      background: transparent;
      .el-menu-item-group__title {
        padding: 0px;
        height: 1px;
        background: #dbdbdb;
      }
      .el-menu-item {
        height: auto;
        line-height: 32px;
        padding: 0px !important;
        min-width: 100%;
        background: $bgCol;
        margin: 5px 0;
        color: #333;
        &:hover{
          color: #213752;
        }
      }
      .el-menu-item{
        a {
          display: block;
          padding: 0 45px;
          padding-left: 12px;
          color: #666;
        }
        .router-link-active {
          color: white;
          background: #213752;
        }
      }
    }
  }
}
</style>
